import { CircularProgress } from "@mui/material";
import { ApexOptions } from "apexcharts";
import * as React from "react";
import ReactApexChart from "react-apexcharts";
import { AuthContext } from "../../context/AuthContext";


interface ChartData {
  series: number[];
  labels: string[];
}

const PaymentsPieVs = () => {
  const { token } = React.useContext(AuthContext) || {};
  const [loading, setLoading] = React.useState<boolean>(false);
  const [chartData, setChartData] = React.useState<ChartData>({
    series: [],
    labels: [],
  });

  React.useEffect(() => {
    setLoading(true);

    const fetchData = async () => {
      let options = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      };

      try {
        const response = await fetch("/api/invoices/vspayments", options);
        const data = await response.json();

        const methodsCount = data.data.map((item: any) => item.percentage);
        const methodsNames = data.data.map((item: any) => item.account_name);

        setChartData({
          series: methodsCount,
          labels: methodsNames,
        });
      } catch (error) {
        console.error("Error fetching invoice payment data:", error);
      }

      setLoading(false);
    };

    fetchData();
  }, [token]);

  const chartOptions: ApexOptions = {
    chart: {
      type: "pie",
    },
    labels: chartData.labels,
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: {
            width: 200,
          },
          legend: {
            position: "bottom",
          },
        },
      },
    ],
    plotOptions: {
      pie: {
        donut: {
          size: "100%",
          labels: {
            show: false,
          },
        },
      },
    },
    dataLabels: {
      style: {
        fontSize: "14px",
        fontWeight: "bold",
        colors: ["white"],
      },
    },
    tooltip: {
      y: {
        formatter: function (value: number) {
          return `${value}%`; // Añadir el símbolo de porcentaje
        },
      },
    },
  };

  return (
    <>
      {!loading ? (
        <ReactApexChart
          options={chartOptions}
          series={chartData.series}
          type="pie"
          height={350}
        />
      ) : (
        <CircularProgress />
      )}
    </>
  );
};

export default PaymentsPieVs;
